import mixpanel from 'mixpanel-browser';
import * as constants from 'common/constants';
import { matchPath } from 'react-router';
import Auth from '@aws-amplify/auth';
import get from 'lodash.get';

/**
 * General definition for a react-router-redux action
 *
 * @typedef {Object} ActionType
 * @property {object} payload payload of the action
 * @property {string} type type of the action
 */

/**
 * Takes a react-router action and fires a mixpanel event if configured.
 *
 * @param {ActionType} action react-router-redux action fired
 */
const routerEvents = action => {
  const pathname = get(action, 'payload.location.pathname');

  // Need a much better way to hook into routes here, might want to export all the routes as a giant matcher to be shared.
  if (
    matchPath(pathname, {
      path: constants.ROUTE_FIELDS_ADD,
      exact: true,
    })
  ) {
    mixpanel.track(constants.ANALYTICS.EVENTS.FIELD.INIT);
  } else if (
    matchPath(pathname, {
      path: constants.ROUTE_FIELDS_DETAIL + '/:season/:fieldname/add',
      exact: true,
    })
  ) {
    mixpanel.track(constants.ANALYTICS.EVENTS.CROP.INIT);
  } else if (
    matchPath(pathname, { path: constants.ROUTE_STORAGE_ADD, exact: true })
  ) {
    mixpanel.track(constants.ANALYTICS.EVENTS.STORAGE.INIT);
  } else if (
    matchPath(pathname, {
      path: constants.ROUTE_ACTIVITY + '/add',
      exact: true,
    })
  ) {
    mixpanel.track(constants.ANALYTICS.EVENTS.ACTIVITY.INIT);
  }
  mixpanel.track('Page View');
};

const getUserInfo = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const attributes = await Auth.currentUserInfo(user);
  mixpanel.people.set({
    $name: `${attributes.attributes.given_name} ${
      attributes.attributes.family_name
    }`,
    $email: attributes.attributes.email,
    [constants.ANALYTICS.PROPERTIES.ACCOUNT.LAST_LOGIN]: new Date(),
  });
  mixpanel.identify(attributes.username);
};

const mixpanelMiddleware = () => next => action => {
  // Need to extract the event names/parameters into constants file.
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      routerEvents(action);
      break;
    case constants.LOGIN_SUCCESS:
      getUserInfo();
      mixpanel.people.set_once({
        [constants.ANALYTICS.PROPERTIES.ACCOUNT.FIRST_LOGIN]: new Date(),
      });
      mixpanel.track(constants.ANALYTICS.EVENTS.ACCOUNT.LOGIN);
      break;
    case constants.REGISTER_SUCCESS:
      // in case, users try to login without confirmation, REGISTER_SUCCESS triggers
      // but no meta data in payload, because not logged in yet > do nothing
      if (!action.payload.meta) {
        break;
      }

      mixpanel.identify(action.payload.user.username);
      mixpanel.track(constants.ANALYTICS.EVENTS.ACCOUNT.REGISTER);
      mixpanel.people.set({
        $name: `${action.payload.meta.firstName} ${
          action.payload.meta.lastName
        }`,
        $email: action.payload.meta.email,
        [constants.ANALYTICS.PROPERTIES.ACCOUNT.FARM_SIZE]:
          action.payload.meta.farmSize,
        [constants.ANALYTICS.PROPERTIES.ACCOUNT.FARM_ADDRESS]:
          action.payload.meta.farmAddress,
      });
      mixpanel.people.set_once({
        [constants.ANALYTICS.PROPERTIES.ACCOUNT.CREATION_DATE]: new Date(),
      });
      break;
    default:
      break;
  }
  next(action);
};

export default mixpanelMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/mixpanelMiddleware.js